<template lang="pug">
  #app.position-relative.w-100.h-100(
    v-cloak
  )
    loading(
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    )
    router-view(
      v-show="!isLoading"
    )
    vue-snotify
</template>

<script>
import Loading from 'vue-loading-overlay';
import { mapState } from 'vuex';

export default {
  name: 'App',
  components: {
    Loading
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.isLoading
    })
  }
};
</script>

<style lang="scss">
//- Main CSS
@import "assets/scss/all";
@import "../node_modules/@fortawesome/fontawesome-free/css/all.css";
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue-icons.min.css';
@import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
@import "~vue-snotify/styles/material";
@import "../node_modules/vue-loading-overlay/dist/vue-loading.css";
</style>
<style>
  @font-face {
    font-family: "NotoSans";
    src: url(../src/assets/font/NotoSansTC-Regular.otf);
  }
  body {
    font-family: 'NotoSans',serif;
  }
</style>
